import * as React from "react"
import JotformEmbed from 'react-jotform-embed';

const Sidebar = () => {
    return (
        <div className=" px-4 w-full bg-sky-600 py-4 ">
            <h3 className="text-center text-white text-xl font-bold">Quick Quote</h3>
            <JotformEmbed src="https://form.jotformeu.com/210911653803450" />
        </div>
    )
}

export default Sidebar
